/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropparticipationlabel2Inputs */

const en_dropparticipationlabel2 = /** @type {(inputs: Dropparticipationlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who can join`)
};

const de_dropparticipationlabel2 = /** @type {(inputs: Dropparticipationlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahme`)
};

/**
* | output |
* | --- |
* | "Who can join" |
*
* @param {Dropparticipationlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropparticipationlabel2 = /** @type {((inputs?: Dropparticipationlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropparticipationlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropparticipationlabel2(inputs)
	return de_dropparticipationlabel2(inputs)
});
export { dropparticipationlabel2 as "dropParticipationLabel" }